<template>
  <div class="product-showcase">
    <div style="color: #f8f9fa; font-size: 1px;">1</div>
    <div class="content-wrapper">
      <SimpleHeader title="產品案例" subtitle="探索改變未來的科技解決方案" />

      <div class="row g-4 gx-5 justify-content-center">
        <div class="col-12 col-md-10 col-lg-6 col-xxl-5" v-for="(product, index) in productList" :key="index">
          <div class="product-card">
            <div class="card-image">
              <img :src="`/api/file/download/${product.image}`" alt="產品圖片" class="image-content" />
              <div class="image-overlay"></div>
              <div class="tech-tag">{{ product.tec_type }}</div>
            </div>

            <div class="card-content">
              <div class="meta-info">
                <span class="category-tag">{{ product.case_type }}</span>
                <div class="awards">
                  <i class="bi bi-award-fill"></i>
                  <span>{{ product.achievement }}</span>
                </div>
              </div>

              <h3 class="title">{{ product.title }}</h3>
              <p class="description">{{ product.introduce }}</p>

              <div class="features">
                <div class="feature-item">
                  <i class="bi bi-check2-circle"></i>
                  {{ product.lable1 }}
                </div>
                <div class="feature-item">
                  <i class="bi bi-check2-circle"></i>
                  {{ product.lable2 }}
                </div>
                <div class="feature-item">
                  <i class="bi bi-check2-circle"></i>
                  {{ product.lable3 }}
                </div>
                <div class="feature-item">
                  <i class="bi bi-check2-circle"></i>
                  {{ product.lable4 }}
                </div>
              </div>

              <a :href="`/article?type=1&id=${encodeURIComponent(JSON.stringify(product.id))}`" class="action-button">
                了解詳情
                <i class="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productList: []
    }
  },
  mounted() {
    this.GetPartnersList()
  },

  methods: {
    //获取产品案例的列表
    GetPartnersList() {
      this.$axios.get(`/product/list?page=1&perPage=100000`)
        .then(res => {
          for (let index = res.data.data.items.length - 1; index >= 0; index--) {
            var data = {
              id: res.data.data.items[index].id,
              title: res.data.data.items[index].title,
              introduce: res.data.data.items[index].introduce,
              content: res.data.data.items[index].content,
              image: res.data.data.items[index].image,
              lable1: res.data.data.items[index].lable1,
              lable2: res.data.data.items[index].lable2,
              lable3: res.data.data.items[index].lable3,
              lable4: res.data.data.items[index].lable4,
              case_type: res.data.data.items[index].case_type,
              achievement: res.data.data.items[index].achievement,
              tec_type: res.data.data.items[index].tec_type,
              read_count: res.data.data.items[index].read_count,
              create_at: res.data.data.items[index].create_at,
              update_at: res.data.data.items[index].update_at
            };
            this.productList.push(data);
          }
        })
        .catch(e => {
          console.log(e)
        })
    },

    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style scoped>
.product-showcase {
  background: linear-gradient(135deg, #f8faff 0%, #f1f6ff 100%);
  padding: 0 0 8rem;
}

.content-wrapper {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 2rem;
}

.product-card {
  background: white;
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: 0 8px 32px rgba(0, 82, 204, 0.08);
  height: 100%;
}

/* .product-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 16px 48px rgba(0, 82, 204, 0.12);
} */

.card-image {
  position: relative;
  height: 360px;
  overflow: hidden;
}

.image-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.4s ease;
}

.product-card:hover .image-content {
  transform: scale(1.08);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(225deg, rgba(0, 102, 255, 0.15) 0%, rgba(0, 163, 255, 0.1) 100%);
}

.tech-tag {
  position: absolute;
  top: 24px;
  left: 24px;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 16px;
  border-radius: 50px;
  font-weight: 600;
  color: #0066ff;
  box-shadow: 0 4px 12px rgba(0, 82, 204, 0.1);
}

.card-content {
  padding: 2rem;
  position: relative;
  z-index: 1;
  background: white;
}

.meta-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.category-tag {
  background: #e6f0ff;
  color: #0066ff;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
}

.awards {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ff9f00;
  font-weight: 500;
}

.awards i {
  font-size: 1.2rem;
}

.title {
  color: #001a40;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 1.2rem;
  position: relative;
  padding-bottom: 1rem;
}

.title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: #0066ff;
  border-radius: 2px;
}

.description {
  color: #4d5a6d;
  font-size: 1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

.features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 2rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4d5a6d;
  padding: 12px;
  background: #f8faff;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.feature-item:hover {
  background: #e6f0ff;
  transform: translateX(4px);
}

.feature-item i {
  color: #0066ff;
}

.action-button {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background: #0066ff;
  color: white !important;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.action-button:hover {
  background: #0052cc;
  box-shadow: 0 8px 16px rgba(0, 102, 255, 0.2);
}

.action-button i {
  margin-left: 10px;
  transition: transform 0.3s ease;
}

/* .action-button:hover i {
  transform: translateX(5px);
} */

@media (max-width: 1200px) {
  .card-image {
    height: 300px;
  }

  .title {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 0 1.5rem;
  }

  .card-image {
    height: 240px;
  }

  .features {
    grid-template-columns: 1fr;
  }

  .action-button {
    width: 100%;
    justify-content: center;
  }
}
</style>